import React, {Component} from 'react';
import './CalendarGraph.css';
import {inject, observer} from 'mobx-react';
import {action} from 'mobx';

const colors = ['#ebedf0', '#c6e48b', '#7bc96f', '#239a3b', '#196127'];
const colorUnused = 'f5f6f8';

@inject('graphStore')
@observer
class CalendarGraph extends Component {
    renderYear() {
        const weeks = [];
        for (let i = 0; i < 53; i++) {
            weeks.push(this.renderWeek(i));
        }
        return weeks;
    };

    renderWeek(week) {
        const {graphStore: {m}} = this.props;
        const rects = [];
        for (let i = 0; i < 7; i++) {
            const cell = m[week][i];
            const color = colors[cell];
            rects.push(
                <rect
                    onClick={() => this.onDayClick(week, i)}
                    onContextMenu={(e) => {
                        e.preventDefault();
                        this.onDayRightClick(week, i);
                    }}
                    width='10'
                    height='10'
                    x={13 - week}
                    y={i * 12}
                    key={i}
                    fill={color}
                />);
        }
        return <g transform={`translate(${week * 13}, 0)`} key={week}>{rects}</g>;
    };

    @action
    onDayClick(week, i) {
        const {graphStore: {m}} = this.props;
        if (m[week][i] === 4) return;
        m[week][i]++;
    }

    @action
    onDayRightClick(week, i) {
        const {graphStore: {m}} = this.props;
        if (m[week][i] === 0) return;
        m[week][i]--;
    }

    onPaletteClick(i) {}

    render() {
        return <div className='border border-gray-dark py-2 graph-before-activity-overview'>
            <div className='calendar-graph height-full'>
                <svg width='669' height='104'>
                    <g transform='translate(16, 20)'>
                        {this.renderYear()}
                        <text x="25" y="-10" className="month">Jan</text>
                        <text x="73" y="-10" className="month">Feb</text>
                        <text x="121" y="-10" className="month">Mar</text>
                        <text x="169" y="-10" className="month">Apr</text>
                        <text x="229" y="-10" className="month">May</text>
                        <text x="277" y="-10" className="month">Jun</text>
                        <text x="325" y="-10" className="month">Jul</text>
                        <text x="385" y="-10" className="month">Aug</text>
                        <text x="433" y="-10" className="month">Sep</text>
                        <text x="493" y="-10" className="month">Oct</text>
                        <text x="541" y="-10" className="month">Nov</text>
                        <text x="589" y="-10" className="month">Dec</text>
                        <text textAnchor="start" className="wday" dx="-14" dy="20">Mon</text>
                        <text textAnchor="start" className="wday" dx="-14" dy="44">Wed</text>
                        <text textAnchor="start" className="wday" dx="-14" dy="69">Fri</text>
                    </g>
                </svg>
            </div>
            <div className='contrib-footer clearfix mt-1 mx-3 px-3 pb-1'>
                <div className='contrib-legend text-gray'>
                    Less
                    <ul className='legend'>
                        <li
                            onClick={() => this.onPaletteClick(0)}
                            style={{backgroundColor: colors[0]}}
                        />
                        {'\n'}
                        <li
                            onClick={() => this.onPaletteClick(1)}
                            style={{backgroundColor: colors[1]}}
                        />
                        {'\n'}
                        <li
                            onClick={() => this.onPaletteClick(2)}
                            style={{backgroundColor: colors[2]}}
                        />
                        {'\n'}
                        <li
                            onClick={() => this.onPaletteClick(3)}
                            style={{backgroundColor: colors[3]}}
                        />
                        {'\n'}
                        <li
                            onClick={() => this.onPaletteClick(4)}
                            style={{backgroundColor: colors[4]}}
                        />
                    </ul>
                    More
                </div>
            </div>
        </div>;
    }
}

export default CalendarGraph;